// extracted by mini-css-extract-plugin
export default {"rotated":"style--rotated--59aed3","goToBaseWrapper":"style--goToBaseWrapper--6654bd","goTo":"style--goTo--9ea988"};